module.exports = __webpack_public_path__ + "img/fi-csv.e20fd8de.svg";